module.exports = __webpack_public_path__ + "media/images/favicon/mstile-150x150-1a1cfc88c577e716332bb22f01c3cfb7.png";